import { apiConfiguration } from "../../api-configuration";
import { BannerApi, BannerSize } from "../../lib-api";
import { getAllBannerIdsToExclude } from "../bannertracking";
import { onBannerElementInserted } from "./banner-events";
import {
  createBannerAnchorElement,
  createPlaceholderBannerAnchorElement,
} from "./banner-utils";

const bannerApi = new BannerApi(apiConfiguration);

const bannerSlotElements =
  document.querySelectorAll<HTMLDivElement>("div.b4nn3r.lazy");

let identityCounter = 0;

(async () => {
  const bannerSlots = Array.from(bannerSlotElements).map((x) => ({
    slotId: `${identityCounter++}`,
    size: x.dataset.size as BannerSize,
    placement: x.dataset.placement as any,
    contentCategoryId: x.dataset.contentcategoryid as string,
    allowPlaceholder: x.dataset.allowplaceholder === "True",
    onlyShowBannersFromBusinessesWithProductId: x.dataset
      .onlyshowbannersfrombusinesseswithproductid as string,
    element: x,
  }));

  const bannerRequests = bannerSlots.map((x) => ({
    slotId: x.slotId,
    allowPlaceholder: x.allowPlaceholder,
    size: x.size,
    contentCategoryId:
      x.contentCategoryId !== "" ? x.contentCategoryId : undefined,
    placement: x.placement !== "" ? x.placement : undefined,
    onlyShowBannersFromBusinessesWithProductId:
      x.onlyShowBannersFromBusinessesWithProductId !== ""
        ? x.onlyShowBannersFromBusinessesWithProductId
        : undefined,
  }));

  const existingBannerIds = getAllBannerIdsToExclude();

  try {
    const banners = await bannerApi.getBannerCollection({
      getBannerCollectionForm: {
        requests: bannerRequests,
        excludeIds: existingBannerIds,
      },
    });

    bannerSlots.forEach((item) => {
      const data = banners[item.slotId];
      //const size = item.size as BannerSize;

      if (data) {
        const anchor = createBannerAnchorElement(data);
        item.element.parentElement?.replaceChild(anchor, item.element);
        onBannerElementInserted(anchor);
      } else {
        //remove!
        if (
          item.element.parentElement &&
          item.element.parentElement.childElementCount == 1
        ) {
          item.element.parentElement.remove();
        } else {
          item.element.remove();
        }
      }
    });
  } catch (e) {
    console.error(e);
  }
})();
